import axios from 'axios';
import qs from 'qs'
import store from '../store/index'
import router from '../router'
import { GetRefreshToken } from '@/api/common/common';
import { REQUEST_AUTH_CODE, REQUEST_MESSAGE } from "@/assets/constant/auth";
import common from "@/assets/js/common";
import { queryResource } from '@/utils/permission';
import Vue from 'vue';
const vm = new Vue();
const service = axios.create({ // axios默认统一数据
    timeout: 5000000,//指定请求超时的毫秒数(0 表示无超时时间)
    baseURL: '/api',
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json;charset=UTF-8',
    }
});
/**递归判断有没有菜单 */
function isMenu(data, str) {
    for (let item of data) {
        if (item.value == str) {
            return item;
        } else {
            if (item.children && item.children.length > 0) {
                var flag = isMenu(item.children, str);
                if (flag) return flag;
            }
        }
    }
    return false;
};
/**获取资源权限 */
function getResource() {
    return new Promise(resolve=>{
        queryResource().then(res => {
            var e=isMenu(res,router.currentRoute.name);
                if (!e || !e.show) {
                    if(router.currentRoute.meta.classify=='manage'){
                        let magSysList = store.state.menu.magSysList;
                        router.push('/magSys/' + magSysList[0].value);
                    }else if(['/theoryTest','/virtualTest'].includes(router.currentRoute.path)){
                        vm.$msg({
                            message: '您已切换账号，请重新进入考核',
                            type: "error",
                            showClose: true,
                            duration: 2 * 1000
                        })
                        let e1=isMenu(res,'/personCenter');
                        if(e1&&e1.show){
                            router.push('/personCenter');
                        }else{
                            router.push('/');
                        }
                    }else{
                        // vm.$msg({
                        //     message: '无此页面权限',
                        //     type: "error",
                        //     showClose: true,
                        //     duration: 2 * 1000
                        // })
                       router.push('/');
                    }
                }
                resolve();
        })
    })
}
function changeTokenTip(){
    let token=common.getCookie("token");
    let userId=common.getCookie("userId");
    vm.$confirm('您的登录信息可能已改变，为确保数据一致性，建议点击确认切换登录。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        sessionStorage.setItem('token',token);
        sessionStorage.setItem('userId',userId);
        window.location.reload();
        // getResource();
      });
};
/**切屏判断是否互串token */
document.addEventListener('visibilitychange', function(e) {
    if (document.visibilityState === 'visible') {
        let sessionUserId=sessionStorage.getItem('userId');
        let userId=common.getCookie("userId");
        let token=common.getCookie("token");
        if(!token){
           store.dispatch('disConnect');
            return;
        }else if(sessionUserId!=userId){
           changeTokenTip();
        }
    }
});
// 添加设置token方法
service.setToken = (token) => {
    service.defaults.headers['Authorization'] = "Bearer " + token;
}
service.interceptors.request.use(
    config => {
        let exTime = Number(common.getCookie("exTime"));
        let token = common.getCookie("token");
        if (token) {
            let sessionUserId=sessionStorage.getItem('userId');
            let userId=common.getCookie("userId");
            if (sessionUserId != userId) {
                changeTokenTip();
                // getResource();
            }
            config.headers.common['Authorization'] = 'Bearer ' + token;
        }
        if (exTime) { 
            // 获取请求的URL
            const requestUrl = config.url;
            let refreshUrl = '/iam/auth/refreshToken';
            // 判断是否为刷新 token 的请求，如果是，则直接返回 config
            if (requestUrl.includes(refreshUrl)) {
                return config;
            }
            const now = new Date().getTime();
            if (now >= exTime) {
                let localRefreshToken = common.getCookie("refreshToken");
                // 是否正在刷新 Token
                if (!store.state.common.isRefreshing&&localRefreshToken) {
                    store.commit('common/changeRefresh', true);
                    GetRefreshToken({ refreshToken: localRefreshToken }).then((response) => {
                        if (response.code === 200) {
                            let res = response.data;
                            store.dispatch('setUserData', res);
                            store.commit('saveInfo');
                            getResource().then(()=>{
                                 // 在刷新 token 完成后，执行队列中的请求
                                 store.state.common.requests.forEach(cb => cb());
                                 store.commit('common/clearRequest');
                            });
                        } else {
                            store.commit('common/clearRequest');
                            loginJump(REQUEST_MESSAGE.TOKEN_EXPIRE);
                            store.commit('del_token');
                        }
                        store.commit('common/changeRefresh', false);
                    })
                        .catch(() => {
                            loginJump(REQUEST_MESSAGE.TOKEN_EXPIRE);
                            store.commit('del_token');
                            store.commit('common/changeRefresh', false);
                        })
                }
                return new Promise((resolve) => {
                    var request = () => {
                        let newToken = common.getCookie("token");
                        config.headers.common['Authorization'] = 'Bearer ' + newToken;
                        resolve(config)
                    }
                    store.commit('common/addRequest', request);
                });
            }
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    },
);



// var flag = true;
//响应拦截器即异常处理
service.interceptors.response.use(response => {
    var fileType = response.headers['file-type'];
    if (fileType && fileType == "attachment") {
        return response;
    }
    const res = response.data;
    if(response.config.url=='/iam/auth/wechatLogin'){
        return res;
    }
    /**
     *  res.code     此编码为http返回码 后端不管是否错误 均返回200
     */
    if (res.code !== REQUEST_AUTH_CODE.SUCCESS) {
        if (REQUEST_AUTH_CODE.UNAUTHORIZED === res.code) {
            loginJump(REQUEST_MESSAGE.TOKEN_EXPIRE)
        } else if (REQUEST_AUTH_CODE.BE_REPLACED === res.code) {
            loginJump(REQUEST_MESSAGE.BE_REPLACED)
        } else if (REQUEST_AUTH_CODE.KICK_OUT === res.code) {
            loginJump(REQUEST_MESSAGE.KICK_OUT)
        } else if (REQUEST_AUTH_CODE.NOT_AUTH === res.code) {
            loginJump(res.msg);
        } else if (REQUEST_AUTH_CODE.NOT_LOGIN === res.code) {
            store.commit('changeGoLogin', 'login');
        }else if (REQUEST_AUTH_CODE.OPT_MOST === res.code) {
            return {};
        }
        else {
            vm.$msg({
                message: res.msg || REQUEST_MESSAGE.ERROR,
                showClose: true,
                type: "error",
                duration: 2 * 1000
            })
            return Promise.reject(new Error(res.msg || REQUEST_MESSAGE.ERROR));
        }
    }
    return res
}, (error) => {
    vm.$msg({
        message: REQUEST_MESSAGE.ERROR,
        type: "error",
        showClose: true,
        duration: 2 * 1000
    })
    return Promise.reject(error);
});
let into=false;
//登录跳转
function loginJump(msg) {
    var tenanId = common.getCookie('tenantId');
    if (tenanId == -1&&router.currentRoute.meta.classify=='manage') {
        router.push('/AdminLogin');
    }else if(router.currentRoute.meta.classify=='manage'){
        store.commit('changeGoLogin', 'login');
    }else {
        into=true;
        router.push('/');
    }
    localStorage.clear();
    common.clearAllCookie();
    store.commit('changeUserInfo', {});
    vm.$msg({
        message: msg || REQUEST_MESSAGE.ERROR,
        type: "error",
        showClose: true,
        duration: 2 * 1000
    })
}
router&&router.afterEach(()=>{
    if(into){
        store.commit('changeGoLogin', 'login');
        into=false;
    }
})
/**
 * 封装get方法
 * @param url
 * @param params
 * @returns {Promise}
 */

export function get(url, params = {}) {
    return new Promise((resolve, reject) => {
        service.get(url, {
            params: params
        })
            .then(response => {
                resolve(response.data);
            })
            .catch(err => {
                reject(err)
            })
    })
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */


export function post(url, data) {
    return new Promise((resolve, reject) => {
        if (navigator.appName === 'Microsoft Internet Explorer') {
            let xhr = new XMLHttpRequest();
            xhr.open("POST", axios.defaults.baseURL + url, true);
            // 添加http头，发送信息至服务器时内容编码类型
            xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
            xhr.send(qs.stringify(data));
            xhr.onreadystatechange = function () {
                if (xhr.readyState == 4 && (xhr.status == 200 || xhr.status == 304)) {
                    resolve(JSON.parse(xhr.responseText))
                }
            };
        }
        else {
            service.post(url, qs.stringify(data))
                .then(response => {
                    resolve(response.data);
                })
                .catch(err => {
                    reject(err)
                })
        }
    })
}



export function json(url, method, data) {
    return new Promise((resolve, reject) => {
        service({
            url: url,
            method: method,
            data: data,
            headers: { 'Content-Type': 'application/json;charset=UTF-8' }
        })
            .then(response => {
                if (response.code === 200) {
                    resolve(response.data);
                }
            }, err => {
                reject(err)
            })
    })
}

/**
 * 封装文件上传
 * @param url
 * @param data
 * @param config
 * @returns {Promise}
 */

export function upload(url, data, config) {
    return new Promise((resolve, reject) => {
        service.post(url, data, config)
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err)
            })
    })
}

/**
 * 文件下载
 * @param url
 * @param data
 * @returns {Promise<unknown>}
 */
export function download(url, data) {
    return new Promise((resolve, reject) => {
        service.post(url, data, {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8'
            },
            responseType: 'blob'
        })
            .then(response => {
                resolve(response);
            }, err => {
                reject(err)
            })
    })
}

/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url, data = {}) {
    return new Promise((resolve, reject) => {
        service.patch(url, data)
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err)
            })
    })
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, data = {}) {
    return new Promise((resolve, reject) => {
        service.put(url, data, {
            headers: {
                'Content-Type': 'application/json'
            },
        })
            .then(response => {
                resolve(response.data);
            }, err => {
                reject(err)
            })
    })
}


export default service;
